import styled from '@emotion/styled/macro';

import { Button } from 'components/buttons';
import IconCheckCircle from 'components/icons/checkCircle';

export const Container = styled.div(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: 16,
}));

export const StatusWrapper = styled.div(() => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: 8,
}));

export const StatusLabel = styled.div((props) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  color: props.theme.colors.inactive,
  fontSize: 12,
  fontWeight: 500,
  lineHeight: '15px',
}));

export const CheckIcon = styled(IconCheckCircle)((props) => ({
  width: 15,
  height: 15,
  overflow: 'visible',
  color: props.theme.colors.inactive,
}));

export const Divider = styled.div((props) => ({
  width: 1,
  height: 10,
  backgroundColor: props.theme.colors.container.tertiary,
}));

export const TitanButton = styled(Button)(() => ({
  padding: '5px 12px',
  minWidth: 150,

  span: {
    fontWeight: 500,
  },
}));

export const ResetButton = styled(Button)(() => ({
  minWidth: 'unset',
  padding: 0,

  span: {
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '15px',
  },
}));

export const CloseButton = styled(Button)(() => ({
  minWidth: 'unset',
  width: 20,
  height: 20,
  padding: 4,

  span: {
    lineHeight: 0.5,
  },
}));
